"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Location_exports = {};
__export(Location_exports, {
  default: () => Location_default
});
module.exports = __toCommonJS(Location_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 5.77734C9.90104 5.77734 9.38672 5.99219 8.95703 6.42188C8.54036 6.83854 8.33203 7.34635 8.33203 7.94531C8.33203 8.54427 8.54036 9.05859 8.95703 9.48828C9.38672 9.90495 9.90104 10.1133 10.5 10.1133C11.099 10.1133 11.6068 9.90495 12.0234 9.48828C12.4531 9.05859 12.668 8.54427 12.668 7.94531C12.668 7.34635 12.4531 6.83854 12.0234 6.42188C11.6068 5.99219 11.099 5.77734 10.5 5.77734ZM7.33594 7.94531C7.33594 7.07292 7.64193 6.33073 8.25391 5.71875C8.87891 5.09375 9.6276 4.78125 10.5 4.78125C11.3724 4.78125 12.1146 5.09375 12.7266 5.71875C13.3516 6.33073 13.6641 7.07292 13.6641 7.94531C13.6641 8.81771 13.3516 9.56641 12.7266 10.1914C12.1146 10.8034 11.3724 11.1094 10.5 11.1094C9.6276 11.1094 8.87891 10.8034 8.25391 10.1914C7.64193 9.56641 7.33594 8.81771 7.33594 7.94531ZM10.5 3.00391C9.83594 3.00391 9.21745 3.1276 8.64453 3.375C8.05859 3.6224 7.54427 3.96745 7.10156 4.41016C6.67188 4.83984 6.33333 5.34766 6.08594 5.93359C5.83854 6.50651 5.71484 7.125 5.71484 7.78906C5.71484 8.11458 5.76693 8.49219 5.87109 8.92188C5.98828 9.35156 6.15104 9.8138 6.35938 10.3086C6.56771 10.8034 6.80859 11.3112 7.08203 11.832C7.35547 12.3398 7.64193 12.8477 7.94141 13.3555C8.42318 14.1758 8.89844 14.9375 9.36719 15.6406C9.84896 16.3438 10.2266 16.8841 10.5 17.2617C10.7734 16.8841 11.1445 16.3438 11.6133 15.6406C12.0951 14.9375 12.5768 14.1758 13.0586 13.3555C13.3581 12.8477 13.6445 12.3398 13.918 11.832C14.1914 11.3112 14.4323 10.8034 14.6406 10.3086C14.849 9.8138 15.0052 9.35156 15.1094 8.92188C15.2266 8.49219 15.2852 8.11458 15.2852 7.78906C15.2852 7.125 15.1615 6.50651 14.9141 5.93359C14.6667 5.34766 14.3216 4.83984 13.8789 4.41016C13.4492 3.96745 12.9414 3.6224 12.3555 3.375C11.7826 3.1276 11.1641 3.00391 10.5 3.00391ZM4.69922 7.78906C4.69922 6.99479 4.85547 6.24609 5.16797 5.54297C5.46745 4.83984 5.8776 4.22786 6.39844 3.70703C6.93229 3.17318 7.55078 2.75651 8.25391 2.45703C8.95703 2.15755 9.70573 2.00781 10.5 2.00781C11.2943 2.00781 12.043 2.15755 12.7461 2.45703C13.4492 2.75651 14.0612 3.17318 14.582 3.70703C15.1159 4.22786 15.5326 4.83984 15.832 5.54297C16.1445 6.24609 16.3008 6.99479 16.3008 7.78906C16.3008 8.21875 16.2292 8.68099 16.0859 9.17578C15.9427 9.67057 15.7669 10.1784 15.5586 10.6992C15.3372 11.2201 15.0833 11.7474 14.7969 12.2812C14.5234 12.8151 14.2305 13.3424 13.918 13.8633C13.319 14.8919 12.7331 15.8164 12.1602 16.6367C11.6003 17.444 11.2227 17.9844 11.0273 18.2578C10.8971 18.4271 10.7214 18.5117 10.5 18.5117C10.2786 18.5117 10.1029 18.4271 9.97266 18.2578C9.77734 17.9844 9.39323 17.444 8.82031 16.6367C8.26042 15.8164 7.68099 14.8919 7.08203 13.8633C6.76953 13.3424 6.47005 12.8151 6.18359 12.2812C5.91016 11.7474 5.66276 11.2201 5.44141 10.6992C5.23307 10.1784 5.05729 9.67057 4.91406 9.17578C4.77083 8.68099 4.69922 8.21875 4.69922 7.78906Z",
      fill: "currentColor"
    }
  )
);
const SvgLocation = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Location_default = SvgLocation;
